import axios from "../axios";

export const getMerchantList = (params) => {
    return axios('get', '/api/merchant/getMerchantList', params);
}

export const getMerchantById = (paramas) => {
    return axios('get', '/api/merchant/getMerchantById', paramas);
}